import React from 'react'
import { CloseCircle, ArrowDown2 } from 'iconsax-react'

import { FilterLogic } from '..'

import PillValue, { PillValueProps } from './PillValue'
import ButtonMenu from '@SonarCX/components/molecules/ButtonMenu'

import { pickFromListSeeded } from '../../../../../utilities'
import useStyles from './styles'

const colors = [
  '#ff6961',
  '#f49ac2',
  '#ff964f',
  '#77dd77',
  '#befd73',
  '#89cff0',
  '#c1c6fc',
  '#bdb0d0',
  '#cb99c9',
  '#ca9bf7'
]

type PillProps = PillValueProps & {
  field: LocalCustomField
  onDelete: () => void
  advanced: boolean
  logic?: FilterLogic
  setLogic?: (logic: FilterLogic) => void
}

const Pill: React.FC<PillProps> = ({
  field,
  onDelete,
  advanced,
  logic,
  setLogic = _ => {},
  ...props
}) => {
  const backgroundColor = React.useMemo(
    () => pickFromListSeeded(colors, field.id),
    [field.id]
  )

  const isDate = React.useMemo(() => {
    const dateTypes = ['date-only', 'date-time', 'month-year']
    return dateTypes.includes(field.field_type)
  }, [field.field_type])

  const options = React.useMemo(() => {
    const opts: FilterLogic[] = ['eq']

    if (isDate) {
      opts.push('gt', 'gte', 'lt', 'lte')
    }

    return opts
  }, [isDate])

  const renderOpt = React.useCallback((opt: string) => {
    const logic = opt as FilterLogic

    if (logic === 'eq') {
      return 'exactly'
    }

    if (logic === 'gt') {
      return 'after'
    }

    if (logic === 'lt') {
      return 'before'
    }

    if (logic === 'gte') {
      return 'after or on'
    }

    if (logic === 'lte') {
      return 'before or on'
    }

    return 'UNKNOWN'
  }, [])

  const classes = useStyles()

  return (
    <div key={field.id} className={classes.root} style={{ backgroundColor }}>
      <div className={classes.title}>{field.title}</div>

      {advanced && (
        <ButtonMenu
          options={options}
          onSelect={logic => setLogic(logic)}
          selected={logic}
          renderFunc={renderOpt}
          className={classes.menu}
          disabled={options.length === 1}
          style={{
            cursor: options.length === 1 ? 'default' : 'pointer'
          }}
        >
          <span style={{ marginRight: '0.5ch' }}>is</span>

          {renderOpt(logic)}

          {options.length !== 1 && <ArrowDown2 className={classes.menuIcon} />}
        </ButtonMenu>
      )}

      <PillValue field={field} advanced={advanced} {...props} />

      <CloseCircle
        onClick={e => {
          e.stopPropagation()
          onDelete()
        }}
        className={classes.icon}
      />
    </div>
  )
}

export default Pill
